import {BotSlider, BlogCard} from '../index'
import {Link} from 'react-router-dom'
import {useEffect, useState} from "react";
import {getNews, getSplash} from "../../services/services";
import {Looks3, Looks4, Looks5, LooksOne, LooksTwo} from '@mui/icons-material'

const Bottombox = () => {

    const [dataNeeded, setData] = useState(false)
    const getdata = async () => {
        const options = {


            params: {take: 4}
        };
        const res = await getNews(options)
        if (res && res.data.code == 1) {

            setData(res.data)
        }
    }

    useEffect(() => {
        getdata().then()

    }, []);


    let content
    if (dataNeeded) {


        content = (
            dataNeeded.items.map((item) => (

                <BlogCard key={item.id} id={item.id} image={item.img} title={item.title} time={item.date_text}/>
            ))
        )
    }


    return (
        <>
            <section>
                <div className='columns mx-0 is-multiline navpadend150 navpadstart150  mt-6'>


                    <div className='column is-12 '>


                        <h3 className='is-size-4-mobile is-size-2-desktop kook has-text-weight-bold has-text-white has-text-centered  '>
                            آخرین اخبار
                        </h3>


                    </div>


                    <div className='column is-12'>

                        <div className='columns is-multiline is-align-items-stretch'>
                            {
                                content
                            }
                        </div>


                        <div className='has-text-centered mt-5'>
                            <Link to={'/news'}>
                                <button

                                    className='button mybutton is-align-self-flex-end px-6 mx-auto   kook  noborder  has-text-weight-bold '
                                    style={{borderRadius: '0.6rem'}}>
                                    مشاهده بیشتر
                                </button>
                            </Link>
                        </div>


                    </div>


                    <div className='column is-12 p-6 '>

                        <div className='columns m-0 is-multiline clrthree  borderrad1 flex-JCS-ACS'>

                            <div className='column is-12 is-12-mobile has-text-centered'>
                                <h4 className='is-size-4-mobile is-size-2-desktop kook has-text-weight-bold has-text-white has-text-centered  '>
                                    دریافت خدمات از بازرگانی قاسمی
                                </h4>
                            </div>


                            <div className='column is-12'>
                                <div className='columns m-0  '>
                                    <div className='column  has-text-centered has-text-white  borderleft1 borderbot1 '>
                                        <img src="/icons/5.png" alt=""/>

                                        <p className='is-size-5 clrtwotext has-text-weight-bold'>
                                            <Looks5/>
                                            تحویل
                                        </p>


                                    </div>

                                    <div className='column has-text-centered   borderleft1 bordertop1'>
                                        <img src="/icons/process.png" alt=""/>

                                        <p className='is-size-5 clrtwotext has-text-weight-bold'>
                                            <Looks4/>
                                            ترخیض کالا
                                        </p>


                                    </div>

                                    <div className='column has-text-centered   borderleft1 borderbot1'>
                                        <img src="/icons/order.png" alt=""/>

                                        <p className='is-size-5 clrtwotext has-text-weight-bold'>
                                            <Looks3/>
                                            ثبت سفارش
                                        </p>


                                    </div>

                                    <div className='column has-text-centered  borderleft1 bordertop1 '>
                                        <img src="/icons/price.png" alt=""/>

                                        <p className='is-size-5 clrtwotext has-text-weight-bold'>
                                            <LooksTwo/>
                                            دریافت قیمت
                                        </p>


                                    </div>

                                    <div className='column has-text-centered  borderbot1 '>


                                        <img src="/icons/choose.png" alt=""/>

                                        <p className='is-size-5 clrtwotext has-text-weight-bold'>
                                            <LooksOne/>
                                            انتخاب محصول
                                        </p>


                                    </div>
                                </div>
                            </div>


                            <div className='column is-12 is-12-mobile mt-6 has-text-white'>

                                <div className='columns m-0 '>

                                    <div className='column is-8 is-12-mobile'>
                                        <h6 className={'is-size-3 clrtwotext'}>
                                            چر بازرگانی قاسمی ؟
                                        </h6>

                                        <div className="content is-size-5">
                                            <ul>

                                                <li>
                                                 محصولاتی بروز
                                                </li>

                                                <li>
                                                   تیم حرفه ای
                                                </li>

                                                <li>
                                                   سرعت کاری بالا
                                                </li>

                                                <li>
                                                   پشتیبانی و پاسخگویی 24 ساعته
                                                </li>

                                                <li>
                                                  سابقه ای درخشان در صادرات و واردات
                                                </li>

                                            </ul>
                                        </div>


                                    </div>

                                    <div className='column is-4 productcard borderrad1 p-5'>
                                        <h5 className='is-size-3'>
                                            بیایید باهم همکاری کنیم !
                                        </h5>

                                        <p className='has-text-justified is-size-5'>
                                            ما دربازرگانی قاسمی بر ارائه خدمات با کیفیت و سریع پایبندیم و در تلاشیم تا
                                            همواره تجربه ای عالی از همکاری با مجموعه بازرگانی قاسمی برای مشتریان خود
                                            ایجاد کنیم !
                                        </p>
                                    </div>


                                </div>

                            </div>


                        </div>

                    </div>


                </div>


            </section>


        </>

    )
}
export default Bottombox